function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.333984 7.00016C0.333984 10.6735 3.32732 13.6668 7.00065 13.6668C10.674 13.6668 13.6673 10.6735 13.6673 7.00016C13.6673 3.32683 10.674 0.333496 7.00065 0.333496C5.76065 0.333496 4.55398 0.673496 3.50732 1.32016C3.19398 1.5135 3.09398 1.92683 3.28732 2.24016C3.48065 2.5535 3.89398 2.64683 4.20732 2.46016C5.04732 1.94016 6.01398 1.66683 7.00065 1.66683C9.94065 1.66683 12.334 4.06016 12.334 7.00016C12.334 9.94016 9.94065 12.3335 7.00065 12.3335C4.06065 12.3335 1.66732 9.94016 1.66732 7.00016C1.66732 6.2935 1.80065 5.6135 2.06732 4.9735C2.20732 4.6335 2.04732 4.24016 1.70732 4.10016C1.36732 3.96016 0.973984 4.12016 0.833984 4.46016C0.500651 5.26683 0.333984 6.12016 0.333984 7.00016Z",
  fill: "#1ECD96"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.00065 7.66683H9.66732C10.034 7.66683 10.334 7.36683 10.334 7.00016C10.334 6.6335 10.034 6.3335 9.66732 6.3335H7.66732V3.04016C7.66732 2.6735 7.36732 2.3735 7.00065 2.3735C6.63398 2.3735 6.33398 2.6735 6.33398 3.04016V7.00016C6.33398 7.36683 6.63398 7.66683 7.00065 7.66683Z",
  fill: "#1ECD96"
});

var SvgClockGreen = function SvgClockGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clockGreen.1c19323f.svg";
export { ForwardRef as ReactComponent };